import { Default, Detail, List,  Create } from "./views";



const Module = {
    name: "locations",
    defaultRoutePath: "/legalentities/location",
    menuItemScope: "legalentities",
    menuItemName: "locations",

    routes: [
        {
            path: "/legalentities/location",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],
    
}

export default Module;
